export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  LOGOUT: '/auth/logout',
  REGISTER_USER: '/auth/registerUser',
  CHECK_USER: '/auth/checkuser',

  // User
  PROFILE: '/user/profile',
  UPDATE_PROFILE: '/user/update-profile',
  UPDATE_NAME: '/user/update-name',
  UPDATE_USER_TIMEZONE: '/user/update-timezone',
  SETTINGS: '/user/settings',

  // Phone Verification
  GENERATE_OTP: '/user/generate-otp',
  VERIFY_OTP: '/user/verify-otp',
  UNVERIFY_PHONE: '/user/unverify-phone-number',

  // Billing
  GENERATE_CUSTOMER_SECRET: '/user/generate-customer-secret',

  // Tasks
  TASKS: '/api/tasks',
  TASK: (id: string) => `/api/tasks/${id}`,

  // Calendar Management (Unified)
  DELETE_SPECIFIC_CALENDAR: (domain: string, calendarId: string) =>
    `/user/calendar/${domain}/${calendarId}`,

  // Google Calendar
  GOOGLE_AUTH_URL: '/user/getGoogleCalendarAuthUrl',
  CONNECT_GOOGLE_CALENDAR: '/user/addCalendar',

  // Outlook Calendar
  OUTLOOK_AUTH_URL: '/integrations/outlook/auth-url',
  CONNECT_OUTLOOK_CALENDAR: '/integrations/outlook/connect',

  // Task Calendar Sync
  SYNC_CALENDAR_EVENTS: '/task/syncAllCalendarEvents',
} as const;
